import React from "react";
import { Link } from "gatsby";
import { CenterLayout } from "components/layouts";
import resume from "assets/resume.pdf";

function PageNavigation() {
  return (
    <nav className="bg-gray-900 w-full py-2 sticky top-0 z-10">
      <CenterLayout>
        <div className="flex items-center justify-between">
          <div className="flex-grow">
            <Link
              to="/"
              className="font-cursive font-medium text-2xl text-gray-100 hidden md:inline mr-8"
            >
              Dahn Alfred S. Registrado
            </Link>
            <Link
              to="/"
              className="font-cursive font-medium text-2xl text-gray-100 inline md:hidden mr-8"
            >
              Dahn
            </Link>
            <Link
              className="text-gray-300 text-base font-semibold hover:text-gray-200 mr-4"
              to="/about"
            >
              About
            </Link>
            <Link
              className="text-gray-300 text-base font-semibold hover:text-gray-200"
              to="/projects"
            >
              Projects
            </Link>
          </div>
          <div>
            <a
              href={resume}
              className="border-2 border-gray-200 text-base text-gray-200 hover:border-gray-100 font-medium hover:text-gray-100 rounded-sm px-4 py-2"
            >
              Resume
            </a>
          </div>
        </div>
      </CenterLayout>
    </nav>
  );
}

export default PageNavigation;
